import IBaseDTO from "src/Interfaces/baseDTO";
import { Control, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { Dispatch, SetStateAction } from "react";

export interface IReportListItem{
    wda002Id:number;
    wda002Titulo:string;
    wda002Ativo:boolean;
    wda001Descricao:string;
    wda002Agrupador:string;
    permission:string;
}

export interface IReport extends IReportListItem,IBaseDTO{
    wda002Sqlquery:string;
    wda002Wda001Id:number
    wda002Tituloabrev?:string;
    wda002Interno:boolean; 
    columns:Array<IWdtba003>
    binds:Array<IWdtba009>
}

export interface IWdtba003{
    id:string;
    wda003Id:number; 
    wda003Nomecoluna:string; 
    wda003Tipocoluna:columnsTypes; 
    wda003Label:string; 
    wda003Ordem:number; 
    wda003Tamanho:number; 
    rules?:Array<IWdtba011>
}

export interface IWdtba011{
    id:string;
    wda011Id:number; 
    wda011Operador?:number; 
    wda011Valor?:string; 
    wda011Valorfim?:string; 
    wda011Tamanhofonte?:number; 
    wda011Negrito?:boolean; 
    wda011Italico?:boolean;  
    wda011Corfonte?:string; 
    wda011Iconesufixo?:string;  
    wda011Iconeprefixo?:string;  
    wda011Corprefixo?:string;
    wda011Avancado?:string; 
    refColumnId?:string;
    showConfig?:boolean;
}

export interface IWdtba009{
    id:string;
    wda009Id:number; 
    wda009Wda002Id:number; 
    wda009Tipo:bindTypes; 
    wda009Bind:string; 
    wda009Sqllov?:string; 
    wda009Label:string; 
    wda009Valordefault:string;
    wda009Ordem:number; 
    wda009Obrigatorio:boolean; 
    showOptions?:boolean;
    options?:Array<IWdtba010>
}

export interface IWdtba010{
    id:string;
    wda010Id:number; 
    wda010Wda009Id:number; 
    wda010Opcao:number; 
    wda010Descricao:string; 
    wda010Valor:string;     
}

export interface IWdtba012{
    id:string;
    wda012Id:number; 
    wda012Wda002Id:number; 
    wda012Efb001Id:number; 
    permissao?:number; 
    titulo:string; 
    tituloAbrev:string;     
    codigo:string;     
}

export enum columnsTypes{
    NUMERIC = "N",
    DATE = "D",
    ALFA_NUMERIC = "A",
    HTML = "H",
}

export enum bindTypes{
    FREE = "1",
    DATE = "2",
    PERIOD = "3",
    OPTIONS_LIST ="4",
    lOV = "5"
}
export interface IReportListFilters{
    active:string;
    filter:string;
}

export interface IReportDeleteItem{
    wda002Id:number;
    wda002Titulo:string;
}

export interface IRefDeleteReportModal {
    actionButtonDelete: (row:IReportDeleteItem,onClose?:()=>void) => void;
}

export interface IRefReportModal {
    actionButtonAdd: (onClose?:(report?:IReport)=>void) => void;
    actionButtonChange: (id:number,duplicate:boolean,onClose?:(report?:IReport)=>void) => void;
}

export interface ITab{
    report:Omit<IReport,"columns"|"binds">;
    columns:IWdtba003[];
    binds:IWdtba009[];
    setColumns:Dispatch<SetStateAction<IWdtba003[]>>;
    setBinds:Dispatch<SetStateAction<IWdtba009[]>>;
    errors:any;
    control:Control<any>;
    setValue:UseFormSetValue<any>;
    register:UseFormRegister<any>;
    unregister?:any;
    getValues?:any;
}

export interface IColumnsTab extends Omit<ITab,"report"|"binds"|"setBinds">{
}

export interface IBindsTab extends Omit<ITab,"report"|"columns"|"setColumns">{
}

export interface IRefconfigColumnModal {
    actionOpen: (index:number,subTitle:string,onClose?:()=>void) => void;
}


